import React from 'react';
import PropTypes from 'prop-types';

import ProviderSurgeIncentiveSearchTableRecord from './provider-surge-incentive-search-table-record-container';

const ProviderSurgeIncentiveTable = ({ surgeIncentives }) => (
  <table>
    <thead>
      <tr>
        <th>Start Date (all times Central)</th>
        <th>End Date (all times Central)</th>
        <th>State</th>
        <th>Amount</th>
        <th />
        <th />
      </tr>
    </thead>
    <tbody>
      {surgeIncentives.map(surgeIncentive => (
        <ProviderSurgeIncentiveSearchTableRecord
          key={surgeIncentive.provider_incentive_cost_id}
          surgeIncentive={surgeIncentive}
        />
      ))}
    </tbody>
  </table>
);

ProviderSurgeIncentiveTable.propTypes = {
  surgeIncentives: PropTypes.array.isRequired
};

export default ProviderSurgeIncentiveTable;
